document.addEventListener('DOMContentLoaded', function() {
    const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
    const modals = document.querySelectorAll('.c-modal-contents__wrap');
    const close_button_modal = document.getElementById('close_button_modal');
    const modal_01 = document.getElementById('modal-01');
    
    close_button_modal.addEventListener('click', ()=>{modal_01.classList.remove('is-open');})

    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(event) {
            event.preventDefault();
            const modalId = this.getAttribute('data-modal-trigger');
            document.getElementById(modalId).classList.add('is-open');
        });
    });

    modals.forEach(modal => {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                modal.classList.remove('is-open');
            }
        });

        const modalContents = modal.querySelector('.c-modal-contents');
        modalContents.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });
});
